import React from "react";

const HealthOverviewContext = React.createContext();

export default HealthOverviewContext;
